// eslint-disable-next-line import/no-default-export
export default function handle404(data: any) {
  if (data && data.updateUser === null) {
    throw new Error('404 error');
  }
}
